import { render, staticRenderFns } from "./c-loader.vue?vue&type=template&id=c9d5e53c"
import script from "./c-loader.vue?vue&type=script&lang=js"
export * from "./c-loader.vue?vue&type=script&lang=js"
import style0 from "./c-loader.vue?vue&type=style&index=0&id=c9d5e53c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports